<template>
  <el-container id="hadoop">
    <el-header>
      <div class="hadoop_top">
        <p class="top_num">
          <span class="allNum">
            宴席报备总数：
            <i class="banquets-report-total">
              {{ checkBB.reportTotal }}
            </i>
          </span>
          <span class="allNum">
            审核数：
            <i class="process-quantity">
              {{ checkBB.examineNum }}</i>
          </span>
          <span class="allNum">
            未审核：
            <i class="unaudited">
              {{ (checkBB.reportTotal) - (checkBB.examineNum) }}
            </i>
          </span>
        </p>
        <p class="top_tit">

          <i>{{ nowCityName }}</i>乡村群宴大数据可视化平台-食安监管中心<span class="edit"
        >版本号：V1.0</span
        >
        </p>
        <span class="goback" @click="goback">返回</span>
      </div>
    </el-header>
    <el-main class="had_cont" style="background: none !important">
      <div class="hadoop_cont">
        <div class="cont_left">
          <div class="tab_one">
            <p class="tab_tit">宴席统计信息</p>
            <div class="one_cont">
              <p class="lf_tab">
                <span class="lf_tab_name">区域</span>
                <span>次数</span>
                <span>桌数</span>
                <span>人次</span>
              </p>
              <div v-for="(item, index) in banquetPersonnel" :key="index">
                <p class="lf_tab">
                  <span class="lf_tab_name">{{ item.areaName }}</span>
                  <!-- 假数据 -->
                  <span class="lf_tab_num">{{ item.total1 }}</span>
                  <span class="lf_tab_num">{{ item.total3 }}</span>
                  <span class="lf_tab_num2">{{ item.total4 }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="tab_one">
            <p class="tab_tit">报备检查信息</p>
            <div class="ech">
              <div class="ech_lf">
                <p>
                  <span>
                    总报备数：
                    <i>{{ checkBB.reportTotal }}</i>
                  </span>
                  <el-progress
                    :text-inside="true"
                    :stroke-width="8"
                    :percentage="100"
                    status="exception"
                  ></el-progress>
                </p>
                <p>
                  <span>
                    审核数：
                    <i>{{ checkBB.examineNum }}</i>
                  </span>
                  <el-progress
                    :text-inside="true"
                    :stroke-width="8"
                    :percentage="checkBB.progress1"
                    color="#11A983"
                    status="exception"
                  />
                </p>
                <p>
                  <span>
                    未审核：
                    <i>{{ (checkBB.reportTotal) - (checkBB.examineNum) }}</i>
                  </span>
                  <el-progress
                    :text-inside="true"
                    :stroke-width="8"
                    :percentage="100 - checkBB.progress1"
                    color="#625bef"
                    status="exception"
                  />
                </p>
              </div>
              <div id="main"/>
            </div>
          </div>
          <div class="tab_one">
            <p class="tab_tit">宴席报备次数</p>
            <div id="main1"></div>
          </div>
          <div class="tab_one">
            <p class="tab_tit">宴席人次概况</p>
            <div id="main2"></div>
          </div>
        </div>
        <div class="cont_in">
          <div class="baidu_Echart">
            <div class="in_top">
              <!--<el-select-->
              <!--  v-model="searchQuery.province"-->
              <!--  placeholder="省份"-->
              <!--  value-key="adcode"-->
              <!--  @change="provinceChange"-->
              <!--&gt;-->
              <!--  <el-option-->
              <!--    v-for="item in provinceList"-->
              <!--    :key="item.adcode"-->
              <!--    :label="item.name"-->
              <!--    :value="item"-->
              <!--  />-->
              <!--</el-select>-->
              <el-select
                v-model="searchQuery.city"
                value-key="adcode"
                placeholder="城市"
                @change="cityChange"
                :clearable="cityClearable"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.adcode"
                  :label="item.name"
                  :value="item"
                />
              </el-select>
              <el-select
                v-model="searchQuery.district"
                value-key="adcode"
                placeholder="区县"
                @change="districtChange"
                :clearable="districtClearable"
              >
                <el-option
                  v-for="item in districtList"
                  :key="item.adcode"
                  :label="item.name"
                  :value="item"
                />
              </el-select>
              <el-select
                v-model="searchQuery.dinnerType"
                placeholder="报备状态"
                @change="dinnerTypeChange"
                clearable
              >
                <el-option
                  v-for="item in report"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-select
                v-model="searchQuery.reportedState"
                placeholder="办宴类型"
                @change="reportedStateChange"
                clearable
              >
                <el-option
                  v-for="item in banquet"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div id="main3"/>
            <!-- 数据统计 -->
            <div class="statis">
              <div>
                <p>报备总数</p>
                <div class="statis-content">
                  <p v-for="(item, index) in (checkBB.reportTotal).toString().split('')" :key="index">
                    <i>{{ item }}</i>
                  </p>
                  <span>次</span>
                </div>
              </div>
              <div>
                <p>审核率</p>
                <div class="statis-content">
                  <p v-for="(item, index) in checkBB.progress1.toString().split('')" :key="index">
                    <i>{{ item }}</i>
                  </p>
                  <span>%</span>
                </div>
              </div>
            </div>
            <p class="onText"><span></span>&nbsp;&nbsp;正在办宴</p>
            <div class="in_num">
              <p>
                <span>区域</span>
                <span>宴席人次</span>
              </p>
              <div v-for="(item, index) in banquetPersonnel.slice(0, 6)" :key="index">
                <p>
                  <span class="name">{{ item.areaName }}：</span>
                  <!-- 假数据 -->
                  <span>{{ item.total4 }}人</span>
                </p>
              </div>
            </div>
            <div class="nowTime">
              <span>当前时间：</span>
              <span id="now-date-time"></span>
              <span> {{ this.dateDayWeek }}</span>
            </div>
          </div>
          <div class="in_btn">
            <div class="tab_one">
              <p class="tab_tit">
                宴席现场监控<i class="morevid" @click="monitorListStatus = true">更多</i>
              </p>
              <div class="video_in_btn" v-if="monitorList.length">
                <div v-for="(item, index) in monitorList" :key="index">
                  <div class="in_vid">
                    <div style="width: 100%">
                      {{ item.banquetPointName }}
                      <span v-if="item.type == 1" class="now-host-banquets">（正在办宴）</span>
                    </div>
                    <p v-for="(x, X) in item.reportCameraInfoList" :key="X" class="in_video">
                      <span>
                        <img
                          @click="openMonitorDrawer(item, x)"
                          :src="x.coverUrl"
                          alt=""
                        />
                      </span>
                      <i>{{ x.position }}</i>
                    </p>
                  </div>
                </div>
              </div>
              <div class="none-control" v-else>
                暂无监控
              </div>
            </div>
            <div>
              <div class="tab_one">
                <p class="tab_tit">区域食安办数量（前五）</p>
                <div id="main5"/>
              </div>
              <div class="tab_one">
                <p class="tab_tit">区域协管员数量（前五）</p>
                <div id="main4"/>
              </div>
            </div>
          </div>
        </div>
        <el-drawer
          title="现场监控"
          :visible.sync="monitorDrawerStatus"
          direction="ltr"
          size="50%"
          class="scenc-control"
        >
          <div class="control-content">
            <div>摄像头地址：{{ monitorData.areasName }}</div>
            <div class="banquets">
              <span class="point">办宴点：{{ monitorData.banquetPointName }}</span>
              <span>摄像头位置：{{ monitorPlaceData.position }}</span>
            </div>
            <p id="ceshia"></p>
          </div>
        </el-drawer>
        <div class="cont_rig">
          <div class="tab_one">
            <p class="tab_tit">宴席报备记录（当月）（前五）</p>
            <div id="main6"/>
          </div>
          <div class="tab_one">
            <p class="tab_tit">食材使用量</p>
            <!--<div id="main7"></div>-->
            <EchartsBar
              :legendData="foodUseQuantityLegend" height="180px" :status="foodUseQuantityStatus"
              :yAxisSeries="foodUseQuantityYaxis" :xAxis="monthXAxis"/>
          </div>
          <div class="tab_one">
            <p class="tab_tit">宴席报备桌数</p>
            <div id="main8"/>
          </div>
          <div class="tab_one">
            <p class="tab_tit">乡厨数量概况</p>
            <div id="main9"/>
          </div>
        </div>
        <el-drawer
          title="宴席现场监控"
          :visible.sync="monitorListStatus"
          size="70%"
          direction="ltr"
          class="scenc-control"
        >
          <div v-if="monitorList.length">
            <div class="more">
              <div
                v-for="(item, index) in monitorList"
                :key="index"
                class="video_more"
              >
                <div class="more_tit">
                  {{ item.banquetPointName }}
                  <span v-if="item.type == 1">（正在办宴）</span>
                </div>
                <div class="more_vid">
                  <p v-for="(x, X) in item.reportCameraInfoList" :key="X">
                    <span>
                      <img
                        @click="openMonitorDrawer(item, x)"
                        :src="x.coverUrl"
                        alt=""
                        style="width: 100%"
                      />
                    </span>
                    <i>{{ x.position }}</i>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="none-control" v-else>暂无监控</div>
        </el-drawer>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import {getSiteName} from "@/utils/site.config";
import echarts from "echarts";
import EchartsBar from "@/components/EchartsBar.vue";
import {banquetTypeList, getCurrentDateTime, getWeekByDays, reportStatusList} from "@/assets/js/public";

export default {
  name: "hadoop",
  components: {
    EchartsBar
  },
  data() {
    return {
      nowCityName: '',
      // 标题,站点名称
      siteName: '',

      // 更多监控列表
      monitorListStatus: false,
      monitorList: [],

      // 监控详情
      monitorDrawerStatus: false,
      monitorData: {},
      monitorPlaceData: {},

      // 当前用户信息
      userdata: {},

      // 当前时间相关
      dateDayWeek: undefined,
      currentDate: new Date(),

      // 搜索条件
      searchQuery: {
        province: undefined,
        city: undefined,
        district: undefined,
        dinnerType: undefined,
        reportedState: undefined
      },

      // 下拉选项
      provinceList: [],
      cityList: [],
      districtList: [],
      report: reportStatusList,
      banquet: banquetTypeList,
      cityClearable: false,
      districtClearable: false,

      // 宴席统计信息和宴席人数的数据源
      banquetPersonnel: [],

      // 统计时段
      monthArr: [],
      yearArr: [],

      // 报备检查
      checkBB: {
        progress1: 0,
        progress2: 0,
        progress3: 0,
        reportTotal: 0,
        examineNum: 0,
      },

      monthXAxis: {
        data: this.getDynamicXData(),
        axisLine: {
          //隐藏X轴轴线
          show: false,
        },
        axisTick: {
          //隐藏X轴刻度
          show: false,
        },
        axisLabel: {
          show: true,
          textStyle: {
            //X轴文字颜色
            color: "#ebf8ac",
          },
        },
      },
      foodUseQuantityYaxis: [],
      foodUseQuantityStatus: false,
      foodUseQuantityLegend: []
    };
  },
  created() {
    this.siteName = getSiteName()
    document.title = this.siteName + '乡村群宴大数据可视化平台'

    this.yearArr = [`${this.currentDate.getFullYear() - 1}`, `${this.currentDate.getFullYear()}`];
    if (this.currentDate.getMonth() > 5) {
      this.monthArr = ["7月", "8月", "9月", "10月", "11月", "12月"];
    } else {
      this.monthArr = ["1月", "2月", "3月", "4月", "5月", "6月"];
    }

    this.userdata = JSON.parse(sessionStorage.getItem("userdata"));
  },
  async mounted() {
    // 按照用户的所属地区,动态显示地图
    if (this.userdata.areasExtend) {
      const areaArr = this.userdata.areasExtend.split(',')
      if (areaArr && areaArr.length > 0) {
        for (let i = 0; i < areaArr.length; i++) {
          const area = await this.getAreaById(areaArr[i])
          if (area) {
            // province
            if (i === 0) {
              this.provinceList = [area]
              this.searchQuery.province = area
              if (i === areaArr.length - 1) {
                await this.provinceChange(area)
                this.cityClearable = true
                this.districtClearable = true
              }
            }
            // city
            else if (i === 1) {
              this.cityList = [area]
              this.searchQuery.city = area
              if (i === areaArr.length - 1) {
                await this.cityChange(area)
                this.districtClearable = true
              }
            }
            // district
            else if (i === 2) {
              this.districtList = [area]
              this.searchQuery.district = area
              if (i === areaArr.length - 1) {
                await this.districtChange(area)
              }
            }
          }
        }
      }
    }

    this.getData()
    this.buildFoodData();

    // 定时刷新数据（目前为30秒）
    let _this = this;
    _this.timer = setInterval(function () {
      _this.getData();
    }, 30000);

    setInterval(() => {
      getCurrentDateTime()
      this.dateDayWeek = getWeekByDays(this.currentDate.getDay())
    }, 1000)

  },
  beforeDestroy() {
    if (this.player) {
      clearInterval(this.timer);
      this.player.remove();
    }
    //清除所有定时器
    clearInterval(this.timer);
  },
  methods: {
    async provinceChange(val) {
      this.cityList = await this.getAreasByPid(val.id)
      this.getLatLng(val.adcode, val.id, true)
    },
    async cityChange(val) {
      if (val) {
        this.districtList = await this.getAreasByPid(val.id)
      } else {
        this.districtList = []
        this.searchQuery.district = undefined
      }
      this.getMap()
    },
    async districtChange(val) {
      this.getMap()
    },
    async getAreasByPid(pid) {
      const {data} = await this.$axios
        .post(`/api-r/area/${pid}/children`, null, {headers: {accessToken: this.userdata.token},})
      return ((data && data.data) || []).filter(i => i.name !== '市辖区')
    },
    async getAreaById(id) {
      const {data} = await this.$axios
        .post(`/api-r/area/${id}`, null, {headers: {accessToken: this.userdata.token},})
      return data && data.data
    },
    getDynamicXData() {
      const curMonth = new Date().getMonth() + 1
      const arr = []
      for (let i = 0; i < 6; i++) {
        let temp = curMonth - i;
        arr.splice(0, 0, (temp <= 0 ? temp + 12 : temp) + '月')
      }
      return arr
    },
    //重新拉取最新数据
    getData() {
      this.getVideo(this.userdata.areasId);
      this.getBanquet(this.userdata.areasId, this.userdata.level);
      this.getInformation(this.userdata.areasId);
      this.getXgy(this.userdata.areasId, this.userdata.level);
      this.getXcinfo(this.userdata.areasId);
      this.getCheck(this.userdata.areasId, this.userdata.level);
      this.getTabNum(this.userdata.areasId, this.userdata.level);
      this.getMap()
    },
    getMap() {
      const area = this.searchQuery.district || this.searchQuery.city || this.searchQuery.province
      if (area) {
        this.getLatLng(area.adcode, area.id, !this.searchQuery.district)
      }
    },
    dinnerTypeChange(val) {
      this.getMap()
    },
    reportedStateChange(val) {
      this.getMap()
    },
    openMonitorDrawer(cityName, place) {
      this.monitorData = cityName;
      this.monitorPlaceData = place;
      const _this = this;
      this.monitorDrawerStatus = true;
      _this.timer = setTimeout(() => {
        _this.player = cyberplayer("ceshia").setup({
          width: "100%", // 宽度，也可以支持百分比（不过父元素宽度要有）
          height: "100%", // 高度，也可以支持百分比
          title: place.position, // 标题
          isLive: true, // 必须设置，表明是直播视频
          file: place.liveUrl, // //您的视频源的地址（目前是乐橙示例播放地址）
          image: place.coverUrl, // 预览图
          autostart: false, // 是否自动播放
          stretching: "uniform", // 拉伸设置
          repeat: false, // 是否重复播放
          volume: 0, // 音量，注：仅当用户同意、网站由用户激活或媒体无声时允许自动播放
          controls: true, // 是否显示控制栏
          hls: {
            reconnecttime: 5, // hls直播重连间隔秒数
          },
          ak: "39f82ac87fc3462ea4dcc78734450f57", // 百度智能云平台注册（https://cloud.baidu.com）即可获得accessKey
        });
      }, 500);
    },
    cityName(val) {
      let cityId = val.adcode;
      let codeId = val.code;
      this.getLatLng(cityId, codeId);
      this.mapData.cityId = cityId;
      this.mapData.codeId = codeId;
      this.getInformation(codeId);
      this.getVideo(codeId);
      this.getXcinfo(codeId);
      let tabLav = 0;
      if (val.name == "全部") {
        tabLav = 0;
        this.nowCityName = "";
        document.title = "乡村群宴大数据可视化平台";
      } else {
        tabLav = 1;
        this.nowCityName = val.name;
        document.title = val.name + "乡村群宴大数据可视化平台";
      }
      this.getBanquet(codeId, tabLav);
      this.getTabNum(codeId, tabLav);
      this.getXgy(codeId, tabLav);
      this.getCheck(codeId, tabLav);
    },
    changeDistrict(val) {
      let cityId = val.adcode;
      let codeId = val.code;
      this.getLatLng(cityId, codeId);
      this.mapData.cityId = cityId;
      this.mapData.codeId = codeId;
      this.getInformation(codeId);
      this.getVideo(codeId);
      this.getXcinfo(codeId);
      let tabLav = 0;
      if (val.name == "全部") {
        tabLav = 0;
        this.nowCityName = "";
        document.title = "乡村群宴大数据可视化平台";
      } else {
        tabLav = 1;
        this.nowCityName = val.name;
        document.title = val.name + "乡村群宴大数据可视化平台";
      }
      this.getBanquet(codeId, tabLav);
      this.getTabNum(codeId, tabLav);
      this.getXgy(codeId, tabLav);
      this.getCheck(codeId, tabLav);
    },
    // 读取map.js地区列表
    aliyunMap() {
      this.mapList = aliyunMap.rows;
      this.districtList = aliyunMap.district;
    },
    // 获取视频信息
    getVideo(areasId) {
      let videos = this.$qs.stringify({
        areasId: areasId,
      });
      this.$axios
        .post(`/api-r/dataCenter/getMonitorInfo`, videos, {
          headers: {accessToken: this.userdata.token},
        })
        .then((res) => {
          if (res.data.success) {
            if (res.data.map[1].length !== 0) {
              res.data.map[1].forEach((x) => {
                x.type = 1;
              });
            }
            let videoArr = [].concat(res.data.map[1]);
            this.monitorList = videoArr.concat(res.data.map[0]);
          }
        });
    },
    // 获取当前区域的协管员数量和食安办
    getXgy(areasId, lev) {
      // 通过x/y坐标绘制图表
      const draw = (xData, yData, eleId) => {
        let option = {
          tooltip: {},
          grid: {
            top: "14%",
            bottom: "25%",
          },
          legend: {
            data: ["威胁值"],
            right: "10%",
            top: "5%",
            textStyle: {
              color: "#fff",
              fontSize: 12,
            },
          },
          xAxis: {
            data: xData, //横坐标
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                color: "#fff",
                fontSize: 12,
              },
            },
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#fff", //坐标线的宽度
              },
            },
          },
          yAxis: [
            {
              type: "value",
              // max: 20,
              splitLine: {
                // show: true,
                lineStyle: {
                  color: "#40A1EA", //网格横线颜色
                },
              },
              axisLabel: {
                show: true,
                formatter: "{value} ",
                textStyle: {
                  color: "#fff",
                  fontSize: 12, //坐标值得具体的颜色
                },
              },
              axisLine: {
                show: false,
              },
            },
          ],
          series: [
            {
              type: "bar",
              barWidth: 20,
              data: yData, //数据
              itemStyle: {
                normal: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 0, color: "#94FFD8"}, //柱图渐变色
                    {offset: 0.5, color: "#5DC0E9"}, //柱图渐变色
                    {offset: 1, color: "#2560DC"}, //柱图渐变色
                  ]),
                },
                emphasis: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    {offset: 0, color: "#2560DC"}, //柱图高亮渐变色
                    {offset: 0.7, color: "#5DC0E9"}, //柱图高亮渐变色
                    {offset: 1, color: "#94FFD8"}, //柱图高亮渐变色
                  ]),
                },
              },
            },
          ],
        };
        echarts.init(
          document.getElementById(eleId),
          "light"
        ).setOption(option)
      }

      // 查询数据构建x/y坐标数据
      const buildData = (params, eleId) => {
        this.$axios.post(`/api-r/dataCenter/getXgStaticsInfo`, this.$qs.stringify(params), {
          headers: {accessToken: this.userdata.token},
        }).then(res => {
          if (res.data.success) {
            let xData = [];
            let yData = [];
            if (res.data.xgStaticsInfoList.length > 0) {
              res.data.xgStaticsInfoList.forEach(function (item, index) {
                if (index < 5) {
                  xData.push(item.areaName);
                  yData.push(item.total);
                }
              });
            }
            draw(xData, yData, eleId)
          }
        })
      }

      buildData({
        level: lev,
        areasId: areasId,
      }, "main4")

      buildData({
        level: lev,
        areasId: areasId,
        n: -4,
      }, "main5")
    },
    // 获取宴席统计信息
    getBanquet(areasId, lev) {
      let data = this.$qs.stringify({
        areasId: areasId,
        isMonth: true,
        level: lev,
        dinnerType: this.dinnerType,
        reportedState: this.reportedState,
      });
      this.$axios
        .post(`/api-r/dataCenter/getBanquetPointList`, data, {
          headers: {accessToken: this.userdata.token},
        })
        .then((res) => {
          if (res.data.success) {
            let circular = [];
            res.data.banquetInfoList.forEach(function (x, index) {
              if (index < 5) {
                circular.push({name: x.areaName, value: x.reportTotal});
              }
            });
            circular = [
              {name: '成都市', value: 3},
              {name: '遂宁市', value: 2},
              {name: '南充市', value: 0},
              {name: '凉山彝族自治州', value: 0},
              {name: '甘孜藏族自治州', value: 0},
            ]
            // 右上角圆圈,拿前5个显示，总数和百分比计算所有的
            let option6 = {
              color: ["#4CDBC7", "#19AEF2", "#FF4248", "#EF752C", "#4E78F1"],
              title: {
                // text: '总数',
                // subtext: 7789,
                // textStyle: {
                //     color: '#f2f2f2',
                //     fontSize: 12,
                //     // align: 'center'
                // },
                // subtextStyle: {
                //     fontSize: 12,
                //     color: ['#ff9d19']
                // },
                // x: '36%',
                // y: 'center',
                // top:'40%'
              },
              grid: {
                // top: "middle",
                top: "40%",
              },
              legend: {
                orient: "vertical",
                top: "middle",
                right: "2%",
                textStyle: {
                  color: "#f2f2f2",
                  fontSize: 12,
                },
                icon: "roundRect",
                data: circular,
              },
              tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b} : {c} ({d}%)",
              },
              series: [
                // 主要展示层的
                {
                  radius: ["30%", "61%"],
                  center: ["40%", "50%"],
                  type: "pie",
                  label: {
                    normal: {
                      show: true,
                      formatter: "{c}次",
                      textStyle: {
                        fontSize: 12,
                      },
                      position: "outside",
                    },
                    emphasis: {
                      show: true,
                    },
                  },
                  labelLine: {
                    normal: {
                      show: true,
                      length: 8,
                      length2: 30,
                    },
                    emphasis: {
                      show: true,
                    },
                  },
                  name: "报备记录",
                  data: circular,
                },
                // 边框的设置
                {
                  radius: ["30%", "34%"],
                  center: ["40%", "50%"],
                  type: "pie",
                  label: {
                    normal: {
                      show: true,
                    },
                    emphasis: {
                      show: true,
                    },
                  },
                  labelLine: {
                    normal: {
                      show: true,
                    },
                    emphasis: {
                      show: true,
                    },
                  },
                  animation: true,
                  tooltip: {
                    show: true,
                  },
                  data: [
                    {
                      value: 1,
                      itemStyle: {
                        color: "rgba(250,250,250,0.3)",
                      },
                    },
                  ],
                },
                {
                  name: "外边框",
                  type: "pie",
                  clockWise: false, //顺时加载
                  hoverAnimation: false, //鼠标移入变大
                  center: ["40%", "50%"],
                  radius: ["65%", "65%"],
                  label: {
                    normal: {
                      show: false,
                    },
                  },
                  data: [
                    {
                      value: 9,
                      name: "",
                      itemStyle: {
                        normal: {
                          borderWidth: 2,
                          borderColor: "#0b5263",
                        },
                      },
                    },
                  ],
                },
              ],
            };
            let myChart6 = echarts.init(
              document.getElementById("main6"),
              "light"
            );
            myChart6.setOption(option6);
          }
        });
    },
    // 获取报备统计次数 和 宴席人次概况
    async getInformation(areasId) {
      const request = async params => {
        return await this.$axios
          .post(`/api-r/dataCenter/getReportStaticsByMonthInfo`, this.$qs.stringify(params), {
            headers: {accessToken: this.userdata.token},
          })
      }

      const oldRes = await request({
        areasId: areasId,
        year: this.currentDate.getFullYear() - 1,
      })
      const newRes = await request({
        areasId: areasId,
        year: this.currentDate.getFullYear(),
      })

      if (!oldRes.data.success || !newRes.data.success) {
        return
      }

      let newYear = newRes.data.reportStaticsByMonthInfoList
      let oldYear = oldRes.data.reportStaticsByMonthInfoList
      let newNum = []
      let oldNum = []
      let newPeop = []
      let oldPeop = []
      if (this.currentDate.getMonth() > 5) {
        newYear.filter(i => i.month > 6).forEach((x) => {
          newNum.push(x.reportTotal);
          newPeop.push(x.dinnerTotal);
        });
        oldYear.filter(i => i.month > 6).forEach((x) => {
          oldNum.push(x.reportTotal);
          oldPeop.push(x.dinnerTotal);
        })
      } else {
        newYear.filter(i => i.month < 7).forEach((x) => {
          newNum.push(x.reportTotal);
          newPeop.push(x.dinnerTotal);
        });
        oldYear.filter(i => i.month < 7).forEach((x) => {
          oldNum.push(x.reportTotal);
          oldPeop.push(x.dinnerTotal);
        });
      }
      let option1 = {
        tooltip: {
          position: function (point) {
            return [point[0], "10%"];
          },
          // formatter:function(p){
          //     var index=p.dataIndex
          //     return '一月税收趋势：<br/>当年税收：0.45亿元<br/>当年税收：0.45亿元'
          // }
        },
        // legend: {
        //   data: this.yearArr,
        //   // right: '0%',
        //   icon: "rect",
        //   top: "6%",
        //   textStyle: {
        //     fontSize: 12,
        //     color: "#fff",
        //   },
        // },
        grid: {
          left: 20,
          right: 20,
          bottom: 30,
          top: 40,
        },
        xAxis: {
          axisTick: {
            show: true,
          },
          axisLabel: {
            fontSize: 12,
            color: "#8cdcfb",
          },
          axisLine: {
            show: true,
          },
          data: this.getDynamicXData(),
        },
        yAxis: {
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: [
          // {
          //   name: this.yearArr[0],
          //   type: "bar",
          //   itemStyle: {
          //     color: "#02FF67",
          //   },
          //   label: {
          //     show: false,
          //   },
          //   // oldNum
          //   data: ['22', '22', '35', '15', '18', '20']
          //   // data: oldNum,
          // },
          {
            name: this.yearArr[1],
            type: "bar",
            itemStyle: {
              // color: "cyan",
              // color: "rgb(147,255,187)",
            },
            label: {
              position: 'top',
              show: true,
            },
            // newNum
            data: ['4', '1', '2', '3', '2', '5']
            // data: newNum,
          },
        ],
      };
      let myChart1 = echarts.init(
        document.getElementById("main1"),
        "light"
      );
      myChart1.setOption(option1);
      let option2 = {
        grid: {
          left: 20,
          right: 20,
          bottom: 30,
          top: 40,
        },
        // legend: {
        //   data: this.yearArr,
        //   icon: "rect",
        //   top: "6%",
        //   // right: "2%",
        //   textStyle: {
        //     color: "#ffffff",
        //     fontSize: "12",
        //   },
        // },
        xAxis: {
          data: this.getDynamicXData(),
          axisLine: {
            show: true, //隐藏X轴轴线
            lineStyle: {
              // color: "#01FCE3",
            },
          },
          type: "category",
          axisTick: {
            show: true, //隐藏X轴刻度
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff", //X轴文字颜色
              fontSize: "12",
            },
          },
        },
        yAxis: [
          {
            type: "value",
            // name: "金额(万元)",
            nameTextStyle: {
              color: "#fff",
              fontSize: "12",
            },
            splitLine: {
              show: false,
            },

            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#FFFFFF",
              },
            },
            axisLabel: {
              show: false,
              textStyle: {
                color: "#fff",
                fontSize: "26",
              },
            },
          },
        ],
        series: [
          {
            name: this.yearArr[0],
            type: "line",
            // yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
            smooth: false, //平滑曲线显示
            showAllSymbol: true, //显示所有图形。
            symbol: "circle", //标记的图形为实心圆
            symbolSize: 10, //标记的大小
            itemStyle: {
              //折线拐点标志的样式
              color: "#ae97ff",
              normal: {label: {show: true}},
            },
            lineStyle: {
              color: "#ae97ff",
              width: 2,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#ae97ffaa",
                },
                {
                  offset: 1,
                  color: "#ae97ff00",
                },
              ]),
            },
            data: [457, 171, 254, 310, 233, 498],
            // data: oldPeop,
          },
          // {
          //   name: this.yearArr[1],
          //   type: "line",
          //   // yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
          //   smooth: false, //平滑曲线显示
          //   showAllSymbol: true, //显示所有图形。
          //   symbol: "circle", //标记的图形为实心圆
          //   symbolSize: 10, //标记的大小
          //   itemStyle: {
          //     //折线拐点标志的样式
          //     color: "#73ffa8",
          //     normal: {label: {show: true}},
          //   },
          //   lineStyle: {
          //     color: "#73ffa8",
          //     width: 2,
          //   },
          //   areaStyle: {
          //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //       {
          //         offset: 0,
          //         color: "#73ffa8aa",
          //       },
          //       {
          //         offset: 1,
          //         color: "#73ffa800",
          //       },
          //     ]),
          //   },
          //   data: [61, 57, 52, 48, 75, 34],
          //   // data: newPeop,
          // },
        ],
      };
      let myChart2 = echarts.init(
        document.getElementById("main2"),
        "light"
      );
      myChart2.setOption(option2);
    },
    // 获取乡厨信息统计
    async getXcinfo(areasId) {
      const request = async params => {
        return await this.$axios
          .post(`/api-r/dataCenter/getXcStaticsByMonthInfo`, this.$qs.stringify(params), {
            headers: {accessToken: this.userdata.token},
          })
      }

      const oldRes = await request({
        areasId: areasId,
        year: this.currentDate.getFullYear() - 1,
      })
      const newRes = await request({
        areasId: areasId,
        year: this.currentDate.getFullYear(),
      })

      if (!oldRes.data.success || !newRes.data.success) {
        return
      }

      let newData = newRes.data.xcStaticsByMonthInfoList;
      let oldData = oldRes.data.xcStaticsByMonthInfoList;
      let newPeop = []
      let oldPeop = []

      if (this.currentDate.getMonth() > 5) {
        newData.filter(i => i.month > 6).forEach(function (x) {
          newPeop.push(x.total);
        })
        oldData.filter(i => i.month > 6).forEach(function (x) {
          oldPeop.push(x.total);
        })
      } else {
        newData.filter(i => i.month < 7).forEach(function (x) {
          newPeop.push(x.total);
        })
        oldData.filter(i => i.month < 7).forEach(function (x) {
          oldPeop.push(x.total);
        })
      }
      let option = {
        grid: {
          left: 20,
          right: 20,
          bottom: 30,
          top: 55,
        },
        // legend: {
        //   data: this.yearArr,
        //   icon: "rect",
        //   top: "6%",
        //   // right: "2%",
        //   textStyle: {
        //     color: "#ffffff",
        //     fontSize: "12",
        //   },
        // },
        xAxis: {
          data: this.getDynamicXData(),
          axisLine: {
            show: true, //隐藏X轴轴线
            lineStyle: {
              // color: "#01FCE3",
            },
          },
          type: "category",
          axisTick: {
            show: true, //隐藏X轴刻度
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff", //X轴文字颜色
              fontSize: "12",
            },
          },
        },
        yAxis: [
          {
            type: "value",
            // name: "金额(万元)",
            nameTextStyle: {
              color: "#fff",
              fontSize: "12",
            },
            splitLine: {
              show: false,
            },

            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#FFFFFF",
              },
            },
            axisLabel: {
              show: false,
              textStyle: {
                color: "#fff",
                fontSize: "26",
              },
            },
          },
        ],
        series: [
          {
            name: this.yearArr[0],
            type: "line",
            // yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
            smooth: false, //平滑曲线显示
            showAllSymbol: true, //显示所有图形。
            symbol: "circle", //标记的图形为实心圆
            symbolSize: 10, //标记的大小
            itemStyle: {
              //折线拐点标志的样式
              color: "#ae97ff",
              normal: {label: {show: true}},
            },
            // 线条颜色
            lineStyle: {
              color: "#ae97ff",
              width: 2,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "#ae97ffaa",
                  },
                  {
                    offset: 1,
                    color: "#ae97ff00",
                  },
                ]
              ),
            },
            data: [7, 7, 9, 10, 12, 15],
          },
          // {
          //   name: this.yearArr[1],
          //   type: "line",
          //   // yAxisIndex: 1, //使用的 y 轴的 index，在单个图表实例中存在多个 y轴的时候有用
          //   smooth: false, //平滑曲线显示
          //   showAllSymbol: true, //显示所有图形。
          //   symbol: "circle", //标记的图形为实心圆
          //   symbolSize: 10, //标记的大小
          //   itemStyle: {
          //     //折线拐点标志的样式
          //     color: "#73FFA8",
          //     normal: {label: {show: true}},
          //   },
          //   lineStyle: {
          //     color: "#73FFA8",
          //     width: 2,
          //   },
          //   areaStyle: {
          //     color: new echarts.graphic.LinearGradient(
          //       0,
          //       0,
          //       0,
          //       1,
          //       [
          //         {
          //           offset: 0,
          //           color: "#08A0F4",
          //         },
          //         {
          //           offset: 1,
          //           color: "#73ffa800",
          //         },
          //       ]
          //     ),
          //   },
          //   data: newPeop,
          // },
        ],
      };
      echarts.init(
        document.getElementById("main9"),
        "light"
      ).setOption(option)
    },
    // 获取周边经纬度(办宴点精准位置、获取地图信息)
    getLatLng(adcode, byCode, full = true) {
      let data = this.$qs.stringify({
        code: adcode,
        full
      });
      // 获取地图信息
      this.$axios.post(`/api-r/dataCenter/GetMapLongitudeAndlatitudeInfo`, data, {
        headers: {accessToken: this.userdata.token},
      }).then((res) => {
        // 办宴点精准位置参数
        let data12 = {
          adminAreasId: byCode,
          dinnerType: this.searchQuery.dinnerType,
          reportedState: this.searchQuery.reportedState,
        }
        // 获取当前筛选地点的办宴点精准位置
        this.$axios.post(`/api-r/report/getReportMap`, this.$qs.stringify(data12), {
          headers: {accessToken: this.userdata.token},
        }).then((msg) => {
          if (msg.data.success) {
            let byDay = [];
            // 办宴地址、日期、时间
            if (msg.data.mapInfos.length > 0) {
              msg.data.mapInfos.forEach((x, i) => {
                byDay.push({
                  name: x.village,
                  value: [x.lng, x.lat],
                  dinnerdays: x.dinnerdays
                });
                byDay = byDay.sort(function (a, b) {
                  return b.dinnerdays - a.dinnerdays;
                })
              });
            }

            echarts.registerMap("mapLine", JSON.parse(res.data.map));
            echarts.init(
              document.getElementById("main3"),
              "light"
            ).setOption({
              // 鼠标放入事件显示
              tooltip: {
                trigger: "item",
                formatter: function (params) {
                  if (params && params.data && params.data.dinnerdays) {
                    return (
                      "办宴地点：" +
                      params.name +
                      "</br>" +
                      "办宴天数：" +
                      params.data.dinnerdays
                    )
                  }
                },
              },
              legend: {
                orient: "vertical",
                y: "bottom",
                x: "right",
                data: ["pm2.5"],
                textStyle: {
                  color: "#fff",
                },
              },
              geo: {
                show: true,
                map: "mapLine",
                zoom: 1,
                label: {
                  normal: {
                    show: true,
                    color: "#73FFA8",
                  },
                  emphasis: {
                    show: true,
                  },
                },
                roam: true,
                itemStyle: {
                  normal: {
                    areaColor: "transparent",
                    borderColor: "#3fdaff",
                    borderWidth: 2,
                    shadowColor: "rgba(63, 218, 255, 0.5)",
                    shadowBlur: 30,
                  },
                  emphasis: {
                    areaColor: "#2B91B7",
                  },
                },
              },
              series: [
                {
                  name: "light",
                  type: "scatter",
                  coordinateSystem: "geo",
                  zoom: 0.2,
                  data: byDay,
                  symbolSize: function (val) {
                    return 10
                  },
                  label: {
                    normal: {
                      formatter: "{b}",
                      position: "right",
                      color: "#F4E925",
                      show: true,
                    },
                    emphasis: {
                      show: true,
                    },
                  },
                  itemStyle: {
                    normal: {
                      color: "#F4E925",
                    },
                  },
                },
                {
                  type: "map",
                  map: "mapLine",
                  zoom: 1,
                  geoIndex: 0,
                  aspectScale: 0.75, //长宽比
                  showLegendSymbol: false, // 存在legend时显示
                  label: {
                    normal: {
                      show: false,
                    },
                    emphasis: {
                      show: false,
                      textStyle: {
                        color: "#fff",
                      },
                    },
                  },
                  roam: true,
                  itemStyle: {
                    normal: {
                      areaColor: "#031525",
                      borderColor: "#FFFFFF",
                    },
                    emphasis: {
                      areaColor: "#2B91B7",
                    },
                  },
                  animation: false,
                  data: data,
                },
                {
                  name: "Top 5",
                  type: "effectScatter",
                  coordinateSystem: "geo",
                  data: byDay.sort(function (a, b) {
                    return b.value - a.value;
                  }).slice(0, 5),
                  symbolSize: function (val) {
                    return 10
                  },
                  showEffectOn: "render",
                  // 波纹特效
                  rippleEffect: {
                    period: 4, //动画时间，值越小速度越快
                    brushType: "stroke", //波纹绘制方式 stroke, fill
                    scale: 6, //波纹圆环最大限制，值越大波纹越大
                  },
                  hoverAnimation: true,
                  label: {
                    normal: {
                      formatter: "{b}",
                      position: "right",
                      show: true,
                    },
                  },
                  itemStyle: {
                    normal: {
                      color: "#F4E925",
                      shadowBlur: 10,
                      shadowColor: "#05C3F9",
                    },
                  },
                  zlevel: 1,
                },
              ]
            }, true);
          }
        });
      });
    },
    // 获取桌数
    async getTabNum(areasId, level) {
      let data = this.$qs.stringify({
        area: areasId,
        pageNum: 1,
        pageSize: 999,
        level: level,
      });
      this.$axios.post(`/api-r/statistics/getBanquetStaticsData`, data, {
        headers: {accessToken: this.userdata.token},
      }).then((res) => {
        if (res.data.success) {
          this.banquetPersonnel = res.data.pageInfo.list;
        }
      });

      const request = async params => {
        return await this.$axios
          .post(`/api-r/dataCenter/getReportStaticsByMonthAndYear`, this.$qs.stringify(params), {
            headers: {accessToken: this.userdata.token},
          })
      }

      const oldRes = await request({
        areasId: areasId,
        year: this.currentDate.getFullYear() - 1,
      })
      const newRes = await request({
        areasId: areasId,
        year: this.currentDate.getFullYear(),
      })

      if (!oldRes.data.success || !newRes.data.success) {
        return
      }

      let newData = newRes.data.reportStaticsByMonthInfoList;
      let oldData = oldRes.data.reportStaticsByMonthInfoList;
      let newPeop = []
      let oldPeop = []

      if (this.currentDate.getMonth() > 5) {
        newData.filter(i => i.month > 6).forEach((x) => {
          newPeop.push(x.dinnerDesk);
        });
        oldData.filter(i => i.month > 6).forEach((x) => {
          oldPeop.push(x.dinnerDesk);
        });
      } else {
        newData.filter(i => i.month < 7).forEach((x) => {
          newPeop.push(x.dinnerDesk);
        });
        oldData.filter(i => i.month < 7).forEach((x) => {
          oldPeop.push(x.dinnerDesk);
        });
      }
      let option = {
        tooltip: {
          position: function (point) {
            return [point[0], "10%"];
          },
          // formatter:function(p){
          //     var index=p.dataIndex
          //     return '一月税收趋势：<br/>当年税收：0.45亿元<br/>当年税收：0.45亿元'
          // }
        },
        // legend: {
        //   data: this.yearArr,
        //   // right: '0%',
        //   icon: "rect",
        //   top: "6%",
        //   textStyle: {
        //     fontSize: 12,
        //     color: "#fff",
        //   },
        // },
        grid: {
          left: 20,
          right: 20,
          bottom: 30,
          top: 55,
        },
        xAxis: {
          axisTick: {
            show: true,
          },
          axisLabel: {
            fontSize: 12,
            color: "#8cdcfb",
          },
          axisLine: {
            show: true,
          },
          data: this.getDynamicXData(),
        },
        yAxis: {
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: [
          // {
          //   name: this.yearArr[0],
          //   type: "bar",
          //   itemStyle: {
          //     color: "#02FF67",
          //   },
          //   label: {
          //     show: false,
          //   },
          //   data: oldPeop,
          // },
          {
            // name: this.yearArr[1],
            type: "bar",
            itemStyle: {
              // color: "cyan",
            },
            label: {
              show: false,
            },
            data: [46, 18, 26, 32, 24, 50],
          },
        ],
      };
      echarts.init(
        document.getElementById("main8"),
        "light"
      ).setOption(option)
    },
    // 获取报备检查信息(宴席报备总数)
    getCheck(type, level) {
      let check = {
        area: type,
        pageNum: 1,
        pageSize: 999,
        level: level
      }
      this.$axios.post(`/api-r/statistics/getReportStaticsData`, this.$qs.stringify(check), {
        headers: {accessToken: this.userdata.token},
      }).then((res) => {
        if (res.data.success) {
          let checkData = res.data;
          // 宴席报备总数
          if (checkData.reportTotal !== 0) {
            res.data.progress1 =
              parseInt((
                (checkData.examineNum / checkData.reportTotal).toFixed(2)
              ) * 100);
            this.checkBB = res.data;
            // 假数据
            this.checkBB.reportTotal = res.data.reportTotal;
            this.checkBB.examineNum = res.data.examineNum;
          } else {
            res.data.progress1 = 0;
            this.checkBB = res.data;
          }
          let option = {
            title: {
              text: checkData.percentage,
              subtext: "审核率",
              x: "center",
              y: "center",
              top: 50,
              textStyle: {
                color: "#fff",
                fontSize: 16,
                fontWeight: "bold",
              },
              subtextStyle: {
                color: "rgba(255,255,255,.45)",
                fontSize: 12,
                fontWeight: "normal",
              },
            },
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)",
            },
            legend: {
              x: "center",
              y: "bottom",
              data: ["rose3", "rose5", "rose6", "rose7", "rose8"],
            },
            calculable: true,
            series: [
              {
                name: "报备检查",
                type: "pie",
                radius: [34, 54],
                center: ["50%", "50%"],
                data: [
                  {
                    value: checkData.examineNum,
                    name: "审核率",
                    itemStyle: {
                      color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                        {
                          offset: 0,
                          color: "#f6e3a1",
                        },
                        {
                          offset: 1,
                          color: "#ff4236",
                        },
                      ]),
                    },
                    label: {
                      color: "rgba(255,255,255,.45)",
                      fontSize: 142,
                      formatter: "完成梳理部门\n{a|34}个",
                      show: false,
                      position: "inner",
                      rich: {
                        a: {
                          color: "#fff",
                          fontSize: 20,
                          lineHeight: 30,
                        },
                      },
                    },
                  },
                  {
                    value: checkData.reportTotal - checkData.examineNum,
                    name: "未检查",
                    itemStyle: {
                      color: "transparent",
                    },
                  },
                ],
              },
              {
                name: "报备检查",
                type: "pie",
                radius: [50, 40],
                center: ["50%", "50%"],
                data: [
                  {
                    value: checkData.examineNum,
                    name: "审核率",
                    itemStyle: {
                      color: "transparent",
                    },
                  },
                  {
                    value: checkData.reportTotal - checkData.examineNum,
                    name: "未检查",
                    itemStyle: {
                      color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                        {
                          offset: 0,
                          color: "#348fe6",
                        },
                        {
                          offset: 1,
                          color: "#625bef",
                        },
                      ]),
                    },
                    label: {
                      color: "rgba(255,255,255,.45)",
                      fontSize: 12,
                      formatter: "部门123321总量\n{a|52}个",
                      show: false,
                      position: "inner",
                      rich: {
                        a: {
                          color: "#fff",
                          fontSize: 10,
                          lineHeight: 30,
                        },
                      },
                    },
                  },
                ],
              },
            ],
          };
          echarts.init(
            document.getElementById("main"),
            "light"
          ).setOption(option)
        }
      });
    },
    goback() {
      this.$router.go(-1);
    },
    buildFoodData() {
      this.foodUseQuantityLegend = ["肉类", "蔬菜"]

      this.foodUseQuantityYaxis = [
        {
          name: '肉类',
          type: "bar",
          barWidth: 10,
          data: [14.0, 31.9, 17.0, 73.2, 25.6, 26.7, 23, 12, 56, 66, 33, 45].sort(),
          // 柱状样式
          color: {
            type: 'linear',
            x: 0, //右
            y: 0, //下
            x2: 0, //左
            y2: 1, //上
            colorStops: [
              {
                offset: 0,
                color: '#6f3d9e' // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#3637a3' // 100% 处的颜色
              }
            ]
          },
        },
        {
          name: '蔬菜',
          type: "bar",
          barWidth: 10,
          data: [44.0, 41.9, 37.0, 63.2, 45.6, 76.7, 23, 45, 12, 54, 23, 55].sort(),
          // 柱状样式
          color: {
            type: 'linear',
            x: 0, //右
            y: 0, //下
            x2: 0, //左
            y2: 1, //上
            colorStops: [
              {
                offset: 0,
                color: '#058cff' // 0% 处的颜色
              },
              {
                offset: 1,
                color: '#058cff' // 100% 处的颜色
              }
            ]
          },
        },
      ]
      this.foodUseQuantityStatus = true
    },
  },
};
</script>
<style lang="scss">

.el-header {
  padding: 0;
}

#hadoop input {
  background-color: #013366b3;
  border: 1px solid #013366b3;
  font-size: 12px;
  line-height: 30px;
  height: 30px;
}

#hadoop .el-input__icon {
  height: 30px;
  line-height: 30px;
}

#hadoop .el-main {
  background: none;
  padding: 10px 20px;
}

@media screen and (max-width: 1200px) {
  #hadoop .el-header {
    height: 100px !important;
  }
}

#hadoop .ceshi {
  background: #013366b3;
}

.el-progress-bar__innerText {
  display: none;
}

.scenc-control {
  .control-content {
    width: 90%;
    margin: 2% auto 4%;
    height: 560px;
    color: #fff;

    .banquets {
      margin: 4% 0;

      .point {
        display: inline-block;
        width: 50%
      }
    }
  }

  .el-drawer__open .el-drawer.ltr {
    background: rgba(13, 18, 98, .9) !important;
  }

  .el-drawer {
    background: rgba(13, 18, 98, .9) !important;
  }

  .el-drawer__header {
    color: #fff;
  }
}

.el-drawer__body {
  overflow-y: auto;
}

/* 修改滚动条样式，目前只支持谷歌 */
.video_in_btn {
  overflow-y: auto;
  height: 258px
}

.one_cont::-webkit-scrollbar,
.video_in_btn::-webkit-scrollbar,
.el-drawer__body::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.had_cont::-webkit-scrollbar,
.el-drawer__body::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 1px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.one_cont::-webkit-scrollbar-thumb,
.had_cont::-webkit-scrollbar-thumb,
.video_in_btn::-webkit-scrollbar-thumb,
.had_cont::-webkit-scrollbar-thumb,
.el-drawer__body::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  background-color: #013366b3;
}

.one_cont::-webkit-scrollbar-track,
.had_cont::-webkit-scrollbar-track,
.video_in_btn::-webkit-scrollbar-track,
.had_cont::-webkit-scrollbar-track,
.el-drawer__body::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #042f52;
}
</style>
<style lang="scss" scoped>
@import "@/assets/css/hadoop.scss";
</style>
